var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":_vm.fluid,"grid-list-lg":"","fill-height":_vm.fillHeight}},[_c('v-fade-transition',{attrs:{"mode":"out-in","appear":""}},[_c('router-view')],1),_vm._v(" "),_c('notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }